import type {PropsWithChildren} from 'react';
import React from 'react';
import type {IntlConfig} from '@sail/intl';
import {IntlProvider, useHasIntlProvider} from '@sail/intl';

const fallbackConfig: IntlConfig = {
  locale: 'en-US',
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'Etc/UTC',
  localeData: {
    locale: 'en-US',
    messages: {},
  },
};

export function IntlFallback({children}: PropsWithChildren) {
  const hasProvider = useHasIntlProvider();

  if (!hasProvider) {
    if (process.env.NODE_ENV === 'development') {
      // Display a message in development mode to raise awareness about Intl API
      // eslint-disable-next-line no-console
      console.log(
        'Sail components work better when properly translated. Consider wrapping your ' +
          'application in an IntlProvider from @sail/intl. \n' +
          'See: https://sail.stripe.me/intl/installation-and-setup/#initialization',
      );
    }

    return <IntlProvider config={fallbackConfig}>{children}</IntlProvider>;
  }

  return children;
}
